export enum AdminAlertSeverity {
  Info = 0,
  Warning = 1,
  Error = 2,
  Critical = 3,
}
